import { Outlet, useLocation } from "react-router-dom";
import HeaderNavbar from "../pages/header/HeaderNavbar";
import Footer from "../pages/footer/FooterNavbar";
import { useEffect, useState } from "react";

const Layout = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const noPaddingRoutes = [
    "lets-talk",
    "Products",
    "blog-view",
    "letter",
    "artificial-intelligence",
    "who-we-are",
    "cloud-managed-services",
    "Home",
    "erp-managed-services"
  ];
  const removePadding =
    noPaddingRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/join-our-team-view/") ||
    location.pathname.endsWith("/apply");

  // Update on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerStyle = {
    maxWidth: "1480px",
    margin: isMobile ? "0px auto" : "80px auto 0 auto",
    paddingLeft: removePadding ? "0px" : isMobile ? "10px" : "48px",
    paddingRight: removePadding ? "0px" : isMobile ? "10px" : "48px",
  };

  return (
    <div>
      <HeaderNavbar />
      <div style={containerStyle}>
        <Outlet />
      </div>
      {/* <div>
        <Subscribenewsletter noPadding />
      </div> */}
      <Footer />
    </div>
  );
};

export default Layout;
